export default __webpack_public_path__ + "static/media/19.4af15010.jpg";